import React from "react";
import type { FormData } from "../types";

interface BasicInfoSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
  subjects: string[];
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  formData,
  onFormChange,
  subjects,
}) => {
  return (
    <>
      <div>
        <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
          Título da Apresentação *
        </label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => onFormChange("title", e.target.value)}
          className="w-full p-3 border border-(--border-color) rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition bg-(--input-bg) text-(--text-primary)"
          placeholder="Ex: Introdução à Álgebra"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
          Matéria/Área *
        </label>
        <select
          value={formData.subject}
          onChange={(e) => onFormChange("subject", e.target.value)}
          className="w-full p-3 border border-(--border-color) rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition bg-(--input-bg) text-(--text-primary)"
        >
          <option value="">Selecione uma matéria</option>
          {subjects.map((subject) => (
            <option key={subject} value={subject}>
              {subject}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
          Tópico Principal *
        </label>
        <input
          type="text"
          value={formData.topic}
          onChange={(e) => onFormChange("topic", e.target.value)}
          className="w-full p-3 border border-(--border-color) rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition bg-(--input-bg) text-(--text-primary)"
          placeholder="Ex: Equações de 1º grau, Fotossíntese..."
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
          Público-alvo *
        </label>
        <select
          value={formData.audience}
          onChange={(e) => onFormChange("audience", e.target.value)}
          className="w-full p-3 border border-(--border-color) rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition bg-(--input-bg) text-(--text-primary)"
        >
          {[
            "Estudantes",
            "Professores",
            "Pais",
            "Administradores",
            "Público Geral",
          ].map((audience) => (
            <option key={audience} value={audience}>
              {audience}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default BasicInfoSection;
